import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { BaseSmallComponent } from '../../base/base-component';

@Component({
    selector: 'close-btn',
    templateUrl: './close-btn.component.html',
    styleUrls: ['./close-btn.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CloseButtonComponent extends BaseSmallComponent {

    @Input()
    testId: string = 'closeBtn';

    @Output() onClose: EventEmitter<any> = new EventEmitter();

    constructor(element: ElementRef,
        renderer: Renderer2
    ) {
        super(element, renderer);
    }

    handleOnClose(evt: Event) {
        this.onClose.emit(evt);
    }
}